<div class="user-copy-dialog" fxLayout="column" fxLayoutGap="10px">
  <h2 mat-dialog-title>{{ isCreated ? 'User created' : 'Copy user' }}</h2>

  <!-- Step 1: name the new user -->
  <div *ngIf="!isCreated" mat-dialog-content fxLayout="column">
    <p class="source-summary">
      Copying <strong>{{ data.userName }}</strong>. Everything below is carried across &mdash;
      only the name, email and password will be new.
    </p>

    <div class="copied-detail" fxLayout="column" fxLayoutGap="6px">
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex="110px" class="label">Company</div>
        <div fxFlex>{{ sourceUser?.companyName || '&mdash;' }}</div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex="110px" class="label">Roles</div>
        <div fxFlex>{{ sourceRoleNames }}</div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex="110px" class="label">Tags</div>
        <div fxFlex>{{ sourceTagCount }}</div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxFlex="110px" class="label">Enabled</div>
        <div fxFlex>{{ sourceUser?.isEnabled ? 'Yes' : 'No' }}</div>
      </div>
    </div>

    <form [formGroup]="copyForm" (ngSubmit)="onCreate()" class="basic-form" fxLayout="column">
      <mat-form-field class="w-100">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" type="email" formControlName="email">
        <mat-error *ngIf="copyForm.get('email')?.hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="copyForm.get('email')?.hasError('pattern')">
          Invalid email address
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>First name</mat-label>
        <input matInput placeholder="First name" type="text" formControlName="firstName">
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>Last name</mat-label>
        <input matInput placeholder="Last name" type="text" formControlName="lastName">
      </mat-form-field>
      <p class="hint">A password will be generated automatically and shown once the user is created.</p>
    </form>
  </div>

  <!-- Step 2: hand over the credentials -->
  <div *ngIf="isCreated" mat-dialog-content fxLayout="column" fxLayoutGap="10px">
    <p>
      <strong>{{ createdUser?.email }}</strong> has been created as a copy of {{ data.userName }}.
      Copy these details now &mdash; the password cannot be shown again.
    </p>

    <div class="credentials" fxLayout="column" fxLayoutGap="8px">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div fxFlex="90px" class="label">Username</div>
        <div fxFlex class="value">{{ createdUser?.email }}</div>
        <button mat-icon-button color="accent" matTooltip="Copy email" (click)="copyEmail()">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div fxFlex="90px" class="label">Password</div>
        <div fxFlex class="value password">{{ generatedPassword }}</div>
        <button mat-icon-button color="accent" matTooltip="Copy password" (click)="copyPassword()">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <p class="hint" *ngIf="tagsCopied > 0">{{ tagsCopied }} tag(s) copied across.</p>
    <p class="warn-text" *ngIf="tagsFailed > 0">
      {{ tagsFailed }} tag(s) could not be copied &mdash; check them on the new user.
    </p>
  </div>

  <div mat-dialog-actions fxLayoutAlign="end center" fxLayoutGap="10px">
    <ng-container *ngIf="!isCreated">
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" type="button"
        [disabled]="copyForm.invalid || loading || saving || !sourceUser"
        [class.button-spinner]="saving"
        (click)="onCreate()">
        <mat-icon>content_copy</mat-icon> Create copy
      </button>
    </ng-container>
    <ng-container *ngIf="isCreated">
      <button mat-stroked-button type="button" (click)="copyLoginDetails()">
        <mat-icon>content_copy</mat-icon> Copy login details
      </button>
      <button mat-button type="button" (click)="onOpenNewUser()">Open new user</button>
      <button mat-flat-button color="primary" type="button" (click)="onDone()">Done</button>
    </ng-container>
  </div>
</div>
